export default __webpack_public_path__ + "src/assets/membership-lifetime.fb2016e254037776288227833a025396.svg";